// extracted by mini-css-extract-plugin
module.exports = {"checkIcon":"SocialTitle-module-checkIcon--Et+VZ","lastTitleText":"SocialTitle-module-lastTitleText--F3JKh"};